import { Plus } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { SEQUENCE_TEMPLATES_PATH } from '@/models/sequenceTemplate'

/** Opens the Sequence Templates page in a new tab, so the sequence being built survives. */
export function CreateSequenceTemplateButton() {
  return (
    <Button
      variant="outline"
      size="sm"
      href={SEQUENCE_TEMPLATES_PATH}
      target="_blank"
      className="justify-start"
    >
      <Plus className="mr-1.5 size-4" />
      Create sequence template
    </Button>
  )
}
